import { z, ZodType } from 'zod';

export type ShiftListItem = {
	id: string;
	startTime: string;
	endTime: string | null;
	currency: string;
	deposits: number;
	withdrawals: number;
	income: number;
};

export const shiftListItemSchema: ZodType<ShiftListItem> = z.object({
	id: z.string(),
	startTime: z.string(),
	endTime: z.string().nullable(),
	currency: z.string(),
	deposits: z.number(),
	withdrawals: z.number(),
	income: z.number(),
});
